import { routerStyxie } from '@/router/styxieBridge'

// `new` is intentionally absent: /gb/widgets/new is a live Vue 2 page the
// Vue 3 index replaced with a modal.
Styxie.Initializers.MobileWidgets = routerStyxie({ actions: ['index', 'edit']})
